import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ChatWidget } from './ChatWidget';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex flex-col h-screen">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-y-auto p-6 bg-dark-950">
          {children}
          {/* Global footer */}
          <footer className="mt-12 pt-6 border-t border-dark-700 text-center text-dark-500 text-xs pb-4">
            <p className="text-dark-400 font-medium">Developed by <span className="text-primary-400">BeAI Energy</span> — 2026</p>
            <p className="mt-1">InverterAI v0.5.1 | Predictive Maintenance for PV Inverters | All Rights Reserved</p>
          </footer>
        </main>
      </div>
      <ChatWidget />
    </div>
  );
}
